/**
 * Makes the AJAX call to Shopify to clear the cart.
 * On success, it attempts to update both sidecart and main cart page UIs.
 */
function ajaxClearCart() {
  console.log('[Custom Script] ajaxClearCart function called');
  const sidecartErrorDisplay = document.querySelector('#CartDrawer-CartErrors');
  const mainCartErrorDisplay = document.querySelector('#MainCartErrors'); 

  if (sidecartErrorDisplay) sidecartErrorDisplay.style.display = 'none';
  if (mainCartErrorDisplay) mainCartErrorDisplay.style.display = 'none';

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' 
    }
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(errorData => {
        throw new Error(errorData.description || `Failed to clear cart. Status: ${response.status}`);
      }).catch(() => {
        throw new Error(`Failed to clear cart. Status: ${response.status}`);
      });
    }
    return response.text().then(text => text ? JSON.parse(text) : {}); 
  })
  .then(data => {
    console.log('[Custom Script] Cart cleared successfully via AJAX. Shopify response:', data); 

    updateSidecartUI(data); 
    updateMainCartPageUI(data); 

    // Dispatch a general 'cart:updated' event that other theme scripts might listen to.
    // The 'product-form.js' also dispatches an event, this ensures consistency.
    document.dispatchEvent(new CustomEvent('cart:updated', { 
      bubbles: true, 
      detail: { 
        cart: data, // Standard Shopify themes often expect the cart object here
        source: 'ajaxClearCart' // Optional: identify the source
      } 
    }));
  })
  .catch((error) => {
    console.error('[Custom Script] Error clearing cart via AJAX:', error.message);
    if (sidecartErrorDisplay) {
      sidecartErrorDisplay.textContent = `Error: ${error.message}`;
      sidecartErrorDisplay.style.display = 'block';
    }
    if (mainCartErrorDisplay) {
      mainCartErrorDisplay.textContent = `Error: ${error.message}`;
      mainCartErrorDisplay.style.display = 'block';
    }
  });
}

/**
 * Updates the Sidecart/Drawer UI based on the provided cartData.
 * Handles both empty and non-empty cart states.
 */
function updateSidecartUI(cartData) {
  console.log('[Custom Script] updateSidecartUI CALLED. Received cartData:', JSON.stringify(cartData, null, 2)); 

  const cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) {
    console.log('[Custom Script] CartDrawer element (#CartDrawer) not found, skipping sidecart UI update.');
    return;
  }

  const currentItemCount = (cartData && typeof cartData.item_count !== 'undefined') ? parseInt(cartData.item_count, 10) : 0;
  console.log(`[Custom Script] updateSidecartUI: Parsed item_count: ${currentItemCount}`);

  // Manage 'is-empty' class on #CartDrawer
  if (currentItemCount === 0) {
      cartDrawer.classList.add('is-empty');
      console.log('[Custom Script] updateSidecartUI: Cart is empty. ADDED "is-empty" class to #CartDrawer.');
  } else {
      cartDrawer.classList.remove('is-empty');
      console.log('[Custom Script] updateSidecartUI: Cart has items. REMOVED "is-empty" class from #CartDrawer.');
  }
  
  const isCartDrawerVisible = window.getComputedStyle(cartDrawer).display !== 'none' || 
                              cartDrawer.classList.contains('is-active') || 
                              cartDrawer.classList.contains('active');
  
  console.log(`[Custom Script] updateSidecartUI: isCartDrawerVisible: ${isCartDrawerVisible}`);

  if (!isCartDrawerVisible) {
    console.log('[Custom Script] updateSidecartUI: Sidecart not deemed visible, skipping further DOM manipulations for visibility. Class "is-empty" state has been set.');
    updateGlobalCartCount(currentItemCount); // Still update global count
    return; 
  }
  
  console.log('[Custom Script] updateSidecartUI: Attempting to update VISIBLE Sidecart UI. Item count:', currentItemCount);

  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  if (!drawerInner) {
    console.warn('[Custom Script] Sidecart UI: .drawer__inner container not found.');
    return;
  }

  const drawerHeader = drawerInner.querySelector('.drawer__header');
  const cartDrawerItemsElement = drawerInner.querySelector('cart-drawer-items'); 
  const cartFooter = drawerInner.querySelector('.drawer__footer');
  let emptyCartContainer = drawerInner.querySelector('.drawer__inner-empty');

  if (currentItemCount === 0) {
    if (drawerHeader) drawerHeader.style.display = 'none';
    if (cartDrawerItemsElement) cartDrawerItemsElement.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'none';

    if (!emptyCartContainer) {
      console.log('[Custom Script] Theme\'s .drawer__inner-empty not found. Creating it.');
      emptyCartContainer = document.createElement('div');
      emptyCartContainer.className = 'drawer__inner-empty';
      drawerInner.appendChild(emptyCartContainer);
    }

    let emptyCartHTML = '';
    emptyCartHTML += '  <div class="cart-drawer__warnings center">';
    emptyCartHTML += '    <div class="cart-drawer__empty-content">';
    emptyCartHTML += '      <h2 class="cart__empty-text" style="display: block;">Your cart is empty</h2>';
    emptyCartHTML += '      <button class="drawer__close" type="button" onclick="const cartDrawerEl = this.closest(\'cart-drawer\') || document.getElementById(\'CartDrawer\'); if(cartDrawerEl && typeof cartDrawerEl.close === \'function\') { cartDrawerEl.close(); } else { console.warn(\'CartDrawer element or its close method not found.\'); }" aria-label="Close">';
    emptyCartHTML += '        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">';
    emptyCartHTML += '          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>';
    emptyCartHTML += '        </svg>';
    emptyCartHTML += '      </button>';
    emptyCartHTML += '      <a href="/collections/all" class="button">Continue shopping</a>';
    emptyCartHTML += '    </div>';
    emptyCartHTML += '  </div>';
    emptyCartContainer.innerHTML = emptyCartHTML;
    emptyCartContainer.style.display = 'block'; 

    const warningsContent = emptyCartContainer.querySelector('.cart-drawer__warnings');
    if (warningsContent) {
      warningsContent.style.display = 'block'; 
    }
    console.log('[Custom Script] updateSidecartUI: Displayed empty cart message.');

  } else { // currentItemCount > 0
    console.log('[Custom Script] updateSidecartUI: Cart has items. Ensuring item sections are visible and empty message is hidden.'); 

    if (drawerHeader) drawerHeader.style.display = ''; 
    if (cartDrawerItemsElement) cartDrawerItemsElement.style.display = ''; 
    if (cartFooter) cartFooter.style.display = ''; 

    if (emptyCartContainer) {
      emptyCartContainer.style.display = 'none'; 
      console.log('[Custom Script] updateSidecartUI: Hiding .drawer__inner-empty container.');
    }
    console.log('[Custom Script] IMPORTANT: Theme\'s product-form.js (or similar) should be re-rendering items and totals now via its own mechanisms (e.g., this.cart.renderContents). This script ensures the overall structure (header/footer/empty message visibility and is-empty class) is correct.');
  }

  const itemsWrapper = drawerInner.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper table.cart-items tbody');
  if (itemsWrapper && currentItemCount === 0) {
    itemsWrapper.innerHTML = ''; 
  }

  updateGlobalCartCount(currentItemCount);
}


/**
 * Updates the Main Cart Page (e.g., /cart) UI to reflect an empty cart.
 */
function updateMainCartPageUI(cartData) {
  const mainCartForm = document.querySelector('form[action="/cart"]:not(#CartDrawer-Form)');
  if (!mainCartForm) {
    return;
  }
  
  const currentItemCount = (cartData && typeof cartData.item_count !== 'undefined') ? parseInt(cartData.item_count, 10) : 0;

  const cartItemsSection = mainCartForm.querySelector('.cart__items, .cart-items, [data-cart-items]');
  const cartFooterSection = mainCartForm.querySelector('.cart__footer, [data-cart-footer]');
  let emptyMessageContainer = mainCartForm.querySelector('.cart--empty-message-container, [data-empty-cart-message]');


  if (currentItemCount === 0) {
    console.log('[Custom Script] Attempting to update Main Cart Page UI to empty state.');
    mainCartForm.classList.add('is-empty');
    if (cartItemsSection) cartItemsSection.style.display = 'none';
    if (cartFooterSection) cartFooterSection.style.display = 'none';

    if (!emptyMessageContainer) {
      console.log('[Custom Script] Theme native empty cart state for main page not found. Injecting custom message.');
      emptyMessageContainer = document.createElement('div');
      emptyMessageContainer.className = 'cart--empty-message-container custom-main-cart-empty-message'; 
      emptyMessageContainer.style.textAlign = 'center';
      emptyMessageContainer.style.padding = '60px 20px';
      const svgIcon = `
          <svg class="empty-cart-icon" viewBox="0 0 24 24" width="80" height="80" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: 20px; color: #888;">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
          </svg>`;
      emptyMessageContainer.innerHTML = svgIcon +
          '<h2>Your Cart is Empty</h2>' +
          '<p>Looks like you haven\'t added anything to your cart yet.</p>' +
          '<p><a href="/collections/all" class="button" style="margin-top:10px;">Continue Shopping</a></p>';
      mainCartForm.prepend(emptyMessageContainer);
    }
    emptyMessageContainer.style.display = 'block';
  } else { // currentItemCount > 0
    console.log('[Custom Script] Main cart has items, removing "is-empty" class and showing item content.');
    mainCartForm.classList.remove('is-empty');
    if (cartItemsSection) cartItemsSection.style.display = '';
    if (cartFooterSection) cartFooterSection.style.display = '';
    if (emptyMessageContainer) emptyMessageContainer.style.display = 'none';
  }
  updateGlobalCartCount(currentItemCount);
}

/**
 * Updates a global cart count element (e.g., in the site header).
 */
function updateGlobalCartCount(count) {
  const currentCount = parseInt(count, 10);
  const globalCountElements = document.querySelectorAll('.site-header__cart-count, .cart-count-bubble, #CartCount');
  
  if (globalCountElements.length > 0) {
    globalCountElements.forEach(el => {
      el.textContent = currentCount.toString();
      if (currentCount === 0) {
        el.classList.add('hidden');
        el.setAttribute('data-cart-count', '0');
      } else {
        el.classList.remove('hidden');
        el.setAttribute('data-cart-count', currentCount.toString());
      }
    });
  } else {
    // console.warn('Global cart count element(s) not found.'); 
  }
}

// --- Event Listener for Theme's Cart Updates ---
// CRITICAL: You MUST verify the actual event name string that your theme's 
// `product-form.js` (or its pub/sub system) uses for `PUB_SUB_EVENTS.cartUpdate`.
// Replace 'cart:updated' below if it's different (e.g., 'theme:cart:update', 'cartchanged').
// Check your theme's pubsub.js or where PUB_SUB_EVENTS is defined.
const THEME_CART_UPDATE_EVENT_NAME = 'cart:updated'; // <<< VERIFY THIS EVENT NAME!

document.addEventListener(THEME_CART_UPDATE_EVENT_NAME, (event) => {
  console.log(`[Custom Script] Global event "${THEME_CART_UPDATE_EVENT_NAME}" CAUGHT. Event detail:`, JSON.stringify(event.detail, null, 2));
  
  let cartDataFromEvent = null;
  if (event.detail) {
    // product-form.js seems to publish { cartData: response }
    if (event.detail.cartData && typeof event.detail.cartData.item_count !== 'undefined') {
      cartDataFromEvent = event.detail.cartData; 
      console.log('[Custom Script] Extracted cartData from event.detail.cartData (expected from product-form.js)');
    } 
    // Standard Shopify themes often use event.detail.cart
    else if (event.detail.cart && typeof event.detail.cart.item_count !== 'undefined') {
      cartDataFromEvent = event.detail.cart; 
      console.log('[Custom Script] Extracted cartData from event.detail.cart (common Shopify pattern)');
    } 
    // Fallback if detail itself is the cart object
    else if (typeof event.detail.item_count !== 'undefined') {
      cartDataFromEvent = event.detail; 
      console.log('[Custom Script] Extracted cartData from event.detail directly');
    } else {
      console.log(`[Custom Script] "${THEME_CART_UPDATE_EVENT_NAME}" event.detail does not contain expected cartData structure. Detail:`, JSON.stringify(event.detail, null, 2));
    }
  } else {
    console.log(`[Custom Script] "${THEME_CART_UPDATE_EVENT_NAME}" event caught, but event.detail is null or undefined.`);
  }

  if (cartDataFromEvent && typeof cartDataFromEvent.item_count !== 'undefined') {
    console.log('[Custom Script] Calling updateSidecartUI from event listener with cartData:', JSON.stringify(cartDataFromEvent, null, 2));
    updateSidecartUI(cartDataFromEvent);
    // updateMainCartPageUI(cartDataFromEvent); // Usually not needed if sidecart is the primary interaction point after add-to-cart
  } else {
    console.warn(`[Custom Script] "${THEME_CART_UPDATE_EVENT_NAME}" event: cartData or item_count is missing/unexpected. Fetching fresh cart state as a fallback.`);
    fetch('/cart.js')
      .then(response => response.json())
      .then(currentCart => {
        console.log('[Custom Script] Fetched fresh cart data due to event data issue:', currentCart);
        updateSidecartUI(currentCart);
        // updateMainCartPageUI(currentCart);
      })
      .catch(e => console.error('[Custom Script] Error fetching fresh cart data after cart:updated event:', e));
  }
});

// --- End Core JavaScript Logic ---